import { render, staticRenderFns } from "./c-end.vue?vue&type=template&id=674f357c&scoped=true&"
import script from "./c-end.vue?vue&type=script&lang=js&"
export * from "./c-end.vue?vue&type=script&lang=js&"
import style0 from "./c-end.vue?vue&type=style&index=0&id=674f357c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f357c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType4: require('D:/Project/kpwebsite/PC/components/content/content-type-4.vue').default})
